import React, { useState } from "react";
import styled from "styled-components";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";

const Layout = () => {
  // 사이드바 관리
  const [sideBarClose, setSideBarClose] = useState<boolean>(false);
  // 모바일 반응형 사이드바 핸들링
  const [sideBarDisplay, setSideBarDisplay] = useState<string>("none");

  return (
    <React.Fragment>
      <Header
        sideBarClose={sideBarClose}
        sideBarDisplay={sideBarDisplay}
        setSideBarDisplay={setSideBarDisplay}
      />
      <Sidebar
        sideBarClose={sideBarClose}
        sideBarDisplay={sideBarDisplay}
        setSideBarClose={setSideBarClose}
        setSideBarDisplay={setSideBarDisplay}
      />
      <Main sideBarClose={sideBarClose}>
        <Outlet />
      </Main>
    </React.Fragment>
  );
};

export default Layout;
const Main = styled.main`
  padding-left: ${(props: { sideBarClose: boolean }) =>
    props.sideBarClose ? "80px" : "250px"};
  transition: all 0.2s ease-in-out;
  padding-right: 20px;
  padding-top: 70px;
  width: 100%;
  min-height: 100vh;
  /* font-size: 14px; */
  @media (max-width: ${(props) => props.theme.breakpoints.Mobile}) {
    width: 100%;
    height: 100%;
    padding-left: 20px;
  }
`;
